import React, { Component, Fragment } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core';
import LoginPage from './pages/LoginPage';
import ProviderTheme from './../themes/ProviderTheme';
import Register from './pages/auth/Register';
import VerifyCode from './pages/auth/VerifyCode';
import ForgetPassword from './pages/auth/resetLogin/ForgetPassword';
import ResetPassword from './pages/auth/resetLogin/resetPassword';
import PostLogin from './pages/auth/postLogin';
import ContactCenter from './pages/ContactCenter';
import MemberEmail from './pages/MemberEmail'

class App extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.state = {
      userIdleTimeOut: false,
    };
  }

  router = () => {
    return (
      <BrowserRouter basename="/member-portals">
        <Switch>
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/verifyMember" component={VerifyCode} />
          <Route exact path="/postLogin" component={PostLogin} />
          <Route exact path="/forgot" component={ForgetPassword} />
          <Route exact path="/resetPassword" component={ResetPassword} />
          <Route exact path="/contactCenter" component={ContactCenter} />
          <Route exact path="/getEmail" component={MemberEmail} />
          <Switch>
            <Redirect exact from="/" to="/login" />
          </Switch>
        </Switch>
      </BrowserRouter>
    );
  };

  render() {
    return (
      <Fragment>
        <MuiThemeProvider theme={ProviderTheme}>
          <div>
            {this.router()}
          </div>
        </MuiThemeProvider>
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return { dispatch };
};

export default compose(connect(mapDispatchToProps))(App);
